// ===== TAB SCROLLING SECTION JAVASCRIPT =====

document.addEventListener('DOMContentLoaded', function() {
  const tabScrollingSection = document.querySelector('.tab-scrolling-section');
  if (!tabScrollingSection) return;

  // Intersection Observer for entrance animation
  function initializeEntranceAnimation() {
    // Add initial hidden state to section
    tabScrollingSection.classList.add('tab-scrolling-hidden');
    
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px', // Trigger when section is 10% visible from bottom
      threshold: 0.1 // Trigger when 10% of section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add 0.2s delay before triggering entrance animation
          setTimeout(() => {
            entry.target.classList.add('tab-scrolling-visible');
            entry.target.classList.remove('tab-scrolling-hidden');
          }, 200);
          
          // Disconnect observer after first animation to prevent re-triggering
          observer.disconnect();
        }
      });
    }, observerOptions);

    observer.observe(tabScrollingSection);
  }

  // Initialize entrance animation
  initializeEntranceAnimation();

  // Tab switching
  const tabs = tabScrollingSection.querySelectorAll('.tab-scrolling-tab');
  const slideGroups = tabScrollingSection.querySelectorAll('.tab-scrolling-slides');
  
  // Store last position for each tab
  const tabPositions = new Map();

  // Initialize first tab as active
  if (tabs.length > 0 && slideGroups.length > 0) {
    const firstTab = tabs[0];
    const firstSlideGroup = slideGroups[0];
    
    firstTab.classList.add('active');
    firstSlideGroup.classList.add('active');
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // Store current position of active tab before switching
      const activeSlideGroup = tabScrollingSection.querySelector('.tab-scrolling-slides.active');
      if (activeSlideGroup) {
        const activeTab = tabScrollingSection.querySelector('.tab-scrolling-tab.active');
        if (activeTab) {
          const activeTabName = activeTab.getAttribute('data-tab');
          const activeContainer = activeSlideGroup.querySelector('.tab-scrolling-slides-container');
          if (activeContainer) {
            // Store the current scroll position for this tab
            tabPositions.set(activeTabName, activeContainer.scrollLeft);
          }
        }
      }
      
      // Update active tab
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Update active slide group
      slideGroups.forEach(group => {
        group.classList.remove('active');
        if (group.getAttribute('data-tab') === targetTab) {
          group.classList.add('active');
          // Initialize slider for this tab with remembered position
          initializeSlider(group, targetTab);
        }
      });
    });
  });

  // Custom Slider Functionality
  function initializeSlider(slideGroup, targetTabName) {
    const container = slideGroup.querySelector('.tab-scrolling-slides-container');
    const slides = slideGroup.querySelectorAll('.tab-scrolling-slide');
    const prevBtn = slideGroup.querySelector('.tab-scrolling-nav-prev');
    const nextBtn = slideGroup.querySelector('.tab-scrolling-nav-next');
    
    if (!container || slides.length === 0) return;
    
    let currentIndex = 0;
    let currentSlideWidth = 0;
    let isScrolling = false;
    let scrollTimeout;
    
    // Create dots navigation
    let dotsContainer = slideGroup.querySelector('.tab-scrolling-dots');
    if (!dotsContainer) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'tab-scrolling-dots';
      slideGroup.appendChild(dotsContainer);
    }
    
    // Clear existing dots
    dotsContainer.innerHTML = '';
    
    // Create dots for each slide
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'tab-scrolling-dot';
      dot.setAttribute('data-index', index);
      dot.addEventListener('click', () => {
        scrollToSlide(index);
        updateDots();
      });
      dotsContainer.appendChild(dot);
    });
    
    // Update dots active state
    function updateDots() {
      const dots = dotsContainer.querySelectorAll('.tab-scrolling-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }
    
    // Function to update current index based on scroll position
    function updateCurrentIndexFromScroll() {
      if (isScrolling) return; // Don't update while programmatically scrolling
      
      const scrollLeft = container.scrollLeft;
      const slideWidth = currentSlideWidth + 10; // slide width + gap
      
      // Calculate which slide is most visible
      let newIndex = Math.round(scrollLeft / slideWidth);
      
      // Ensure index is within bounds
      newIndex = Math.max(0, Math.min(newIndex, slides.length - 1));
      
      // Only update if the index actually changed
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateNavigationVisibility();
        updateDots();
      }
    }
    
    // Improved scroll handler with debouncing
    function handleScroll() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(() => {
        updateCurrentIndexFromScroll();
      }, 100); // Debounce scroll events
    }
    
    // Add scroll event listener to detect manual scrolling
    function addScrollListener() {
      const container = slideGroup.querySelector('.tab-scrolling-slides-container');
      if (container) {
        // Use passive: true for better performance
        container.addEventListener('scroll', handleScroll, { passive: true });
      }
    }
    
    // Show/hide navigation arrows based on slide count
    function updateNavigationVisibility() {
      // Determine slides to show based on screen size
      let slidesToShow = 3; // desktop default
      let peekPercentage = 0; // no peek on desktop
      
      if (window.innerWidth <= 580) {
        slidesToShow = 1; // mobile
        peekPercentage = 0; // no peek on mobile
      } else if (window.innerWidth <= 980) {
        slidesToShow = 2; // tablet
        peekPercentage = 0; // no peek on tablet
      }
      
      if (slides.length <= slidesToShow) {
        prevBtn?.classList.remove('show');
        nextBtn?.classList.remove('show');
        return;
      }
      
      // Show prev button if not at the beginning
      prevBtn?.classList.toggle('show', currentIndex > 0);
      
      // Show next button if there are more slides to show
      const maxIndex = slides.length - slidesToShow;
      nextBtn?.classList.toggle('show', currentIndex < maxIndex);
    }
    
    // Calculate slide width and update container
    function updateSlideWidth() {
      const containerWidth = container.offsetWidth;
      const gap = 10; // gap between slides
      
      // Determine slides to show based on screen size
      let slidesToShow = 3; // desktop default
      let peekPercentage = 0; // no peek on desktop
      
      if (window.innerWidth <= 580) {
        slidesToShow = 1; // mobile - show exactly 1 slide
        peekPercentage = 0; // no peek on mobile
      } else if (window.innerWidth <= 980) {
        slidesToShow = 2; // tablet
        peekPercentage = 0; // no peek on tablet
      }
      
      if (slides.length <= slidesToShow) {
        // If we have fewer slides than we can show, distribute them evenly
        currentSlideWidth = (containerWidth - (slides.length - 1) * gap) / slides.length;
      } else {
        // Calculate width to show the specified number of slides
        currentSlideWidth = (containerWidth - (slidesToShow - 1) * gap) / slidesToShow;
      }
      
      slides.forEach(slide => {
        slide.style.width = `${currentSlideWidth}px`;
        slide.style.flexShrink = 0;
      });
      
      updateNavigationVisibility();
    }
    
    // Scroll to specific slide with improved snap behavior
    function scrollToSlide(index) {
      const targetSlide = slides[index];
      if (targetSlide) {
        isScrolling = true; // Prevent scroll event handling during programmatic scroll
        
        const container = targetSlide.closest('.tab-scrolling-slides-container');
        if (container) {
          const slideLeft = targetSlide.offsetLeft;
          const containerWidth = container.offsetWidth;
          const slideWidth = currentSlideWidth;
          const gap = 10; // gap between slides
          
          // Calculate the scroll position
          let scrollPosition = slideLeft;
          
          // Ensure scroll position is within bounds
          const maxScroll = container.scrollWidth - containerWidth;
          scrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));
          
          // Use smooth scrolling within the container only
          container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
        
        currentIndex = index;
        updateNavigationVisibility();
        updateDots();
        
        // Reset scrolling flag after animation completes
        setTimeout(() => {
          isScrolling = false;
        }, 500); // Match the CSS transition duration
      }
    }
    
    // Next slide
    function nextSlide() {
      // Determine slides to show based on screen size
      let slidesToShow = 3; // desktop default
      
      if (window.innerWidth <= 580) {
        slidesToShow = 1; // mobile
      } else if (window.innerWidth <= 980) {
        slidesToShow = 2; // tablet
      }
      
      if (currentIndex < slides.length - slidesToShow) {
        scrollToSlide(currentIndex + 1);
      }
    }
    
    // Previous slide
    function prevSlide() {
      if (currentIndex > 0) {
        scrollToSlide(currentIndex - 1);
      }
    }
    
    // Event listeners for navigation
    prevBtn?.addEventListener('click', prevSlide);
    nextBtn?.addEventListener('click', nextSlide);
    
    // Initialize slider
    updateSlideWidth();
    
    // Check if we have a remembered position for this tab
    let initialIndex = 0;
    let shouldScrollToPosition = false;
    
    if (targetTabName && tabPositions.has(targetTabName)) {
      const rememberedScrollLeft = tabPositions.get(targetTabName);
      const slideWidth = currentSlideWidth + 10; // slide width + gap
      initialIndex = Math.round(rememberedScrollLeft / slideWidth);
      initialIndex = Math.max(0, Math.min(initialIndex, slides.length - 1));
      shouldScrollToPosition = true;
    }
    
    // Initialize with remembered position or first slide
    currentIndex = initialIndex;
    updateNavigationVisibility();
    updateDots();
    
    // Force first slide on mobile for better UX
    if (window.innerWidth <= 580 && !shouldScrollToPosition) {
      const container = slideGroup.querySelector('.tab-scrolling-slides-container');
      if (container) {
        container.scrollLeft = 0;
      }
    }
    
    // If we have a remembered position, scroll to it
    if (shouldScrollToPosition) {
      const container = slideGroup.querySelector('.tab-scrolling-slides-container');
      if (container) {
        const targetSlide = slides[initialIndex];
        if (targetSlide) {
          const slideLeft = targetSlide.offsetLeft;
          container.scrollLeft = slideLeft;
        }
      }
    }
    
    // Add scroll listener after initialization
    addScrollListener();
    
    // Handle window resize
    window.addEventListener('resize', () => {
      updateSlideWidth();
      // Don't auto-scroll on resize to prevent jumping
      updateNavigationVisibility();
      updateDots();
      
      // Ensure mobile stays at first slide after resize
      if (window.innerWidth <= 580) {
        const container = slideGroup.querySelector('.tab-scrolling-slides-container');
        if (container) {
          container.scrollLeft = 0;
        }
      }
    });
  }
  
  // Initialize slider for the first active tab
  const activeSlideGroup = tabScrollingSection.querySelector('.tab-scrolling-slides.active');
  if (activeSlideGroup) {
    const activeTab = tabScrollingSection.querySelector('.tab-scrolling-tab.active');
    if (activeTab) {
      const activeTabName = activeTab.getAttribute('data-tab');
      initializeSlider(activeSlideGroup, activeTabName);
    }
  }

  // Popup functionality with improved mobile handling
  const popupButtons = tabScrollingSection.querySelectorAll('.tab-scrolling-slide-button');
  const popups = tabScrollingSection.querySelectorAll('.tab-scrolling-popup');

  popupButtons.forEach(button => {
    // Use both click and touchstart for better mobile compatibility
    button.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent event bubbling
      const popupId = this.getAttribute('data-popup-id');
      const popup = document.getElementById(popupId);
      if (popup) {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
    
    // Add touchstart event for mobile
    button.addEventListener('touchstart', function(e) {
      e.stopPropagation(); // Prevent event bubbling
      e.preventDefault(); // Prevent default touch behavior
      const popupId = this.getAttribute('data-popup-id');
      const popup = document.getElementById(popupId);
      if (popup) {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }, { passive: false });
  });

  // Close popup functionality using event delegation
  document.addEventListener('click', function(e) {
    // Close button click
    if (e.target.classList.contains('tab-scrolling-popup-close')) {
      const popup = e.target.closest('.tab-scrolling-popup');
      if (popup) {
        popup.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
    
    // Click outside popup to close
    if (e.target.classList.contains('tab-scrolling-popup')) {
      e.target.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  // Close popup with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activePopup = document.querySelector('.tab-scrolling-popup.active');
      if (activePopup) {
        activePopup.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
  });

  // Mobile image switching
  function handleMobileImages() {
    const slides = tabScrollingSection.querySelectorAll('.tab-scrolling-slide');
    const isMobile = window.innerWidth <= 768;
    
    slides.forEach(slide => {
      const mobileImage = slide.getAttribute('data-mobile-image');
      const desktopImage = slide.getAttribute('data-desktop-image');
      
      if (mobileImage && isMobile) {
        slide.style.backgroundImage = `url('${mobileImage}')`;
      } else if (!isMobile && desktopImage) {
        slide.style.backgroundImage = `url('${desktopImage}')`;
      }
    });
  }

  // Handle mobile images on load and resize
  handleMobileImages();
  window.addEventListener('resize', handleMobileImages);
}); 